document.addEventListener("DOMContentLoaded", function () {

  function trackKlaviyoAddToCart(cartData, targetVariantId) {
      if (!cartData || !cartData.items) return;

      // Find the specific item we just added (using loose equality for string vs number IDs)
      const addedItem = cartData.items.find(item => item.id == targetVariantId);

      if (addedItem) {
        var _learnq = window._learnq || [];

        // EXTRACT DATA DIRECTLY FROM CART RESPONSE
        // discounted_price: The actual price paid (e.g., $27.00 for subscription)
        // total_discount: The savings amount (e.g., $18.00)
        // original_price: The base SKU price (e.g., $45.00)
        
        var pricePaid = addedItem.discounted_price / 100;
        var discountAmt = addedItem.total_discount / 100;
        var originalPrice = addedItem.original_price / 100;

        var itemPayload = {
          Name: addedItem.product_title,
          ProductID: addedItem.product_id,
          ImageURL: addedItem.image,
          URL: window.location.origin + addedItem.url,
          Brand: addedItem.vendor,
          // Standard Klaviyo Price Field (Usually Base Price)
          Price: originalPrice,
          CompareAtPrice: originalPrice,
          // --- CUSTOM REQUIREMENTS ---
          VariantID: addedItem.variant_id,
          first_month_subscription_price: pricePaid,
          discount: discountAmt,
          quantity: addedItem.quantity,
          environment: "shopify"
        };

        _learnq.push(['track', 'Added to Cart Custom', itemPayload]);
      }
    }
    // ----------------------------------------

  subscribe(PUB_SUB_EVENTS.cartDrawerClose, () => {
    if (cartCloseTimeout) {
      clearTimeout(cartCloseTimeout);
      cartCloseTimeout = null;
    }
  });
  // Reusable function to apply discount codes
  function applyDiscountCode(productForm) {
    const subscriptionDiscountCodeFromForm = productForm.getAttribute("data-hf-discount-subscription");
    const oneTimeDiscountCodeFromForm = productForm.getAttribute("data-hf-discount-onetime");
    const bundleDiscountCodeFromForm = productForm.getAttribute("data-hf-bundle-discount-code");
    const bundleDiscountCodeSubscriptionFromForm = productForm.getAttribute("data-hf-bundle-discount-code-subscription");
    
    // Determine if the selected option is a subscription or one-time purchase
    const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
    let discountCodeToApply = null;
    
    if (sellingPlanInput && sellingPlanInput.value) {
      // Subscription selected
      discountCodeToApply = subscriptionDiscountCodeFromForm;
    } else {
      // One-time purchase selected
      discountCodeToApply = oneTimeDiscountCodeFromForm;
    }

    if (bundleDiscountCodeFromForm) {
      discountCodeToApply = bundleDiscountCodeFromForm;
    }

    if (bundleDiscountCodeSubscriptionFromForm && sellingPlanInput && sellingPlanInput.value) {
      discountCodeToApply = bundleDiscountCodeSubscriptionFromForm;
    } else if (bundleDiscountCodeFromForm && (!sellingPlanInput || !sellingPlanInput.value)) {
      discountCodeToApply = bundleDiscountCodeFromForm;
    }

    if (discountCodeToApply) {
      // Set the discount code in a cookie to be read on cart page load
      const expiryDate = new Date();
      expiryDate.setTime(expiryDate.getTime() + 15 * 60 * 1000); // 15 minutes expiry
      document.cookie = `discount_code=${discountCodeToApply}; expires=${expiryDate.toUTCString()}; path=/`;
    }
    
    const discount_code = document.cookie
      .split(";")
      .find((row) => row.includes("discount_code"))
      ?.split("=")[1];

    if (discount_code) {
      // The most reliable way is to redirect to the discount URL which applies the discount
      // This will apply the discount and redirect back to cart
      // Determine the correct cart URL based on locale
      let cartUrl = '/cart';
      if (window.location.pathname.startsWith("/es/") || window.location.pathname === "/es") {
        cartUrl = '/es/cart';
      } else if (window.location.pathname.startsWith("/fr/") || window.location.pathname === "/fr") {
        cartUrl = '/fr/cart';
      }
      window.location.href = `/discount/${discount_code}?redirect=${encodeURIComponent(cartUrl)}`;
      return true; // Indicates we're redirecting
    }
    return false; // No discount to apply
  }

  // Add to Cart button selector
  const addToCartButtons = document.querySelectorAll(
    ".tvg_recharge_product_add_to_cart_form_nGmuOW_ProductForm-submitButton"
  );
  const atcBtns = document.querySelectorAll(
    ".tvg_recharge_product_add_to_cart_form_widget_foYHaW_ProductForm-submitButton"
  );

  const shopAllAtcBtns = document.querySelectorAll(".js-shop-all-atc");
  const shopAllAtcBtnsB2B = document.querySelectorAll(".js-shop-all-atc-b2b");

  const productAtcBtns = document.querySelectorAll(".js-product-atc");

  const reploATCBtn = document.querySelectorAll(
    "[data-replo-add-product-variant-to-cart]"
  );

  const conversationTracking = (variantId) => {
    if (
      variantId === "39353652117609" ||
      variantId === "39353652150377" ||
      variantId === "39353652183145"
    ) {
      // Trigger Convert Experiments conversion tracking for Mushroom Coffee 30 Serving ATC
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "100462016"]);
    } else if (variantId === "32925928751209") {
      // Check if the variant belongs to Starter Kit product
      // Trigger Convert Experiments conversion tracking for Starter Kit ATC
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "100462017"]);
    }
  };

  let cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  let cartCloseTimeout;

  if (reploATCBtn) {
    reploATCBtn.forEach((button) => {
      button.addEventListener("click", async function (event) {
        if (window.isCali) {
          document
            .querySelectorAll(".js-subscription-product")
            .forEach((el) => {
              el.style.display = "block";
            });
        }

        event.stopPropagation();
        event.preventDefault();
        window.cartDrawer && window.cartDrawer.resetCountdown();

        var originalButtonText = button.textContent;
        button.style.display = "flex";
        button.style.justifyContent = "center";
        button.innerHTML = `<div class="loading__spinner__add-to-cart"></div>`;
        const productFormContainer = button.closest(
          "[data-replo-product-container]"
        );
        const productForm = productFormContainer.querySelector("form");

        if (productForm) {
          const variantInput = productForm.querySelector('input[name="id"]');
          const sellingPlanInput = productForm.querySelector(
            'input[name="selling_plan"]'
          );
          if (variantInput) {
            const variantId = variantInput.value;
            conversationTracking(variantId);
            let body = {
              id: variantId,
              quantity: 1,
            };
            if (sellingPlanInput) {
              body = { ...body, selling_plan: sellingPlanInput.value };
            }
            const productInput = productForm.querySelector(
              "input[data-productId]"
            );
            // Resolve free gifts: dynamic sale first, legacy fallback (see getGiftProductsToAdd in theme.liquid)
            let groupProductsToAdd = [];
            if (productInput) {
              const productId = productInput.getAttribute("data-productId");
              groupProductsToAdd = await window.getGiftProductsToAdd(productId);
            }

            groupProductsToAdd.unshift(body);
            const response = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: groupProductsToAdd,
              }),
            });

            // btn.isClicked = true;
            // cart drawer:
            if (cart && cart.classList.contains("drawer")) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "add-to-cart",
                cartData: await response.json(),
                tagName: "CART-DRAWER-ITEMS",
                sections: cart
                  .getSectionsToRender()
                  .map((section) => section.id),
              });
              button.innerHTML = originalButtonText;

              setTimeout(() => {
                if (cart && cart.classList.contains("is-empty"))
                  cart.classList.remove("is-empty");
                cart.renderContents(response);
              });

              if (
                window.cart_drawer_auto_close_delay &&
                window.cart_drawer_auto_close_delay > 0
              ) {
                cartCloseTimeout = setTimeout(() => {
                  cart.close();
                }, window.cart_drawer_auto_close_delay);
              }
            } else {
              // not using cart drawer:
              // Apply discount after successful product addition
              const discountApplied = applyDiscountCode(productForm);
              
              setTimeout(() => {
                if (window.location.pathname.startsWith("/es/") || window.location.pathname === "/es") {
                  window.location.href = "/es/cart";
                } else if (window.location.pathname.startsWith("/fr/") || window.location.pathname === "/fr") {
                  window.location.href = "/fr/cart";
                } else {
                  window.location.href = "/cart";
                }
                }, window.cart_redirect_delay || 0);
            }
          }
        }
      });
    });
  }

  if (atcBtns) {
    atcBtns.forEach((button) => {
      handleButtonClick(button);
    });
  }

  if (shopAllAtcBtns) {
    shopAllAtcBtns.forEach((button) => {
      handleButtonClick(button, true);
    });
  }

  if (shopAllAtcBtnsB2B) {
    shopAllAtcBtnsB2B.forEach((button) => {
      handleButtonClick(button, true, false, false, true);
    });
  }

  if (productAtcBtns) {
    productAtcBtns.forEach((button) => {
      handleButtonClick(button, true);
    });
  }

  if (addToCartButtons) {
    addToCartButtons.forEach((button) => {
      button.addEventListener("click", async function (event) {
        if (window.isCali) {
          document
            .querySelectorAll(".js-subscription-product")
            .forEach((el) => {
              el.style.display = "block";
            });
        }

        event.stopPropagation();
        event.preventDefault();
        window.cartDrawer && window.cartDrawer.resetCountdown();
        // button.disabled = true;
        // Check if the button is for any of the Mushroom Coffee 30 Serving variants

        // const btn = event.target.closest(
        //   ".tvg_recharge_product_add_to_cart_form_nGmuOW_ProductForm-submitButton"
        // );

        // if (btn.isClicked) return;

        // Save original button text (if network request fails, we'll remove the spinner and put the original text back)
        var originalButtonText = button.textContent;

        // Swap the button text with our loader
        button.innerHTML = `<div class="loading__spinner__add-to-cart"></div>`;

        var productForm = button.closest("form");
        if (productForm) {
          var confirmationFailure = productForm.querySelector(
            "#confirmation-failure"
          );
          var variantInput = productForm.querySelector('input[name="id"]');
          const sellingPlanInput = productForm.querySelector(
            'input[name="selling_plan"]'
          );
          if (variantInput) {
            var variantId = variantInput.value;
            conversationTracking(variantId);
            let body = {
              id: variantId,
              quantity: 1,
            };
            if (sellingPlanInput) {
              body = { ...body, selling_plan: sellingPlanInput.value };
            }

            const productInput = productForm.querySelector(
              "input[data-product-id]"
            );
            if (productInput) {
              const productId = productInput.getAttribute("data-product-id");
              // Resolve free gifts: dynamic sale first, legacy fallback (see getGiftProductsToAdd in theme.liquid)
              let groupProductsToAdd = await window.getGiftProductsToAdd(productId);

              groupProductsToAdd.unshift(body);

              // Check if we already have this product in the cart (7434931208297 superfood creamer, 7462384959593 chai)
              // This is a promo product that should only be able to be added once
              const creamerPromoProductId = 7434931208297;
              const chaiPromoProductId = 7462384959593;
              const cocoaPromoProductId = 7468768723049;
              let skipAdd = false;
              if (creamerPromoProductId || chaiPromoProductId) {
                const cartContentsRequest = await fetch(
                  window.Shopify.routes.root + "cart.js"
                );

                if (cartContentsRequest.ok) {
                  const cartContents = await cartContentsRequest.json();
                  cartContents.items.forEach((item) => {
                    if (
                      item.product_id == creamerPromoProductId ||
                      item.product_id == chaiPromoProductId ||
                      item.product_id == cocoaPromoProductId
                    ) {
                      skipAdd = true;
                    }
                  });
                }
              }

              if (skipAdd) {
                // just redirect to the cart
                // check if current page starts with /es or /fr locale prefix
                if (window.location.pathname.startsWith("/es/") || window.location.pathname === "/es") {
                  window.location.href = "/es/cart";
                } else if (window.location.pathname.startsWith("/fr/") || window.location.pathname === "/fr") {
                  window.location.href = "/fr/cart";
                } else {
                  window.location.href = "/cart";
                }
              } else {
                const response = await fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    items: groupProductsToAdd,
                    sections: cart
                      .getSectionsToRender()
                      .map((section) => section.id),
                  }),
                });
                if (response.ok) {
                  const responseForKlaviyo = response.clone();

                try {
                  const klaviyoData = await responseForKlaviyo.json();
                  trackKlaviyoAddToCart(klaviyoData, variantId);
                } catch (err) {
                  console.error("Klaviyo Tracking Error:", err);
                }

                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "add-to-cart",
                    cartData: await response.json(),
                    tagName: "CART-DRAWER-ITEMS",
                    sections: cart
                      .getSectionsToRender()
                      .map((section) => section.id),
                  });
                  // btn.isClicked = true;

                  // Apply discount after successful product addition
                  const discountApplied = applyDiscountCode(productForm);

                  if (!discountApplied) {
                    // If no discount to apply, proceed with normal redirect
                    window._conv_q = window._conv_q || [];
                    _conv_q.push(["triggerConversion", "100461720"]);
                    setTimeout(() => {
                      // check if current page starts with /es or /fr locale prefix
                      if (window.location.pathname.startsWith("/es/") || window.location.pathname === "/es") {
                        window.location.href = "/es/cart";
                      } else if (window.location.pathname.startsWith("/fr/") || window.location.pathname === "/fr") {
                        window.location.href = "/fr/cart";
                      } else {
                        window.location.href = "/cart";
                      }
                    }, window.cart_redirect_delay || 0);
                  }

                  window._conv_q = window._conv_q || [];
                  _conv_q.push(["triggerConversion", "100461720"]);
                  setTimeout(() => {
                    setTimeout(() => {
                      if (cart && cart.classList.contains("is-empty"))
                        cart.classList.remove("is-empty");
                      cart.renderContents(response);
                    });
                    if (
                      window.cart_drawer_auto_close_delay &&
                      window.cart_drawer_auto_close_delay > 0
                    ) {
                      cartCloseTimeout = setTimeout(() => {
                        cart.close();
                      }, window.cart_drawer_auto_close_delay);
                    }
                  }, window.cart_redirect_delay || 0);
                  button.innerHTML = originalButtonText;
                } else {
                  // If the network request failed, just reset the button with the original text and throw an error
                  button.innerHTML = originalButtonText;
                  confirmationFailure.classList.remove("hidden");
                  throw new Error("Network response was not ok");
                }
              }
            }
          }
        }
      });
    });
  }

  var cartForm = document.getElementById("cartform");

  if (cartForm) {
    var shopMoneyFormat =
      document.getElementById("shop-money-format").dataset.moneyFormat;
    var quantityInputs = cartForm.querySelectorAll(".cart-quantity-input");

    quantityInputs.forEach((input) => {
      var productId = input
        .closest(".cart-item")
        .getAttribute("data-cart-item-id");

      // 41903044755561 is superfood creamer (50% discount promo)
      // 42034475827305 is chai (50% discount promo)
      if (
        productId === "41212477669481" ||
        productId === "41934688649321" ||
        productId === "42034475827305" ||
        productId === "42061107265641"
      ) {
        input.value = 1;
        input.disabled = true;
        input
          .closest(".tvg_cart_7EowpW_CartItem__qty")
          .classList.add("disable-quantity-buttons");
      } else {
        input.addEventListener("change", function (event) {
          event.preventDefault();
          var quantity = input.value;

          const tr = input.closest("tr");
          const variant_id = tr.getAttribute("data-cart-item-id");

          if (quantity > 0) {
            fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                id: variant_id,
                quantity: quantity,
              }),
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                return response.json();
              })
              .then((cart) => {
                updateCartDisplay(cart);

                // Convert Experiments conversion tracking
                window._conv_q = window._conv_q || [];
                _conv_q.push(["triggerConversion", "100461720"]);
              })
              .catch((error) => {
                console.error(
                  "There was a problem with the fetch operation:",
                  error
                );
              });
          }
        });
      }
    });
  }

  function updateCartDisplay(cart) {
    cart.items.forEach((item) => {
      var itemElement = document.querySelector(
        `.cart-item[data-line-item-id="${item.key}"]`
      );

      if (itemElement) {
        var originalLinePrice =
          item.selling_plan_allocation.compare_at_price * item.quantity;
        itemElement.querySelector(".item-total-price").innerText =
          Shopify.formatMoney(item.final_line_price, shopMoneyFormat);
        itemElement.querySelector(".item-original-price").innerText =
          Shopify.formatMoney(originalLinePrice, shopMoneyFormat);
      }
    });

    var totalElement = document.querySelector(
      ".tvg_cart_7EowpW_Cart-totalPrice"
    );
    if (totalElement) {
      totalElement.innerText = Shopify.formatMoney(
        cart.total_price,
        shopMoneyFormat
      );
    }
  }

  /**
   * @param {HTMLElement} productForm 
   * @returns {function(string): boolean} 
   */
  function createGiftGuard(productForm) {
    const card = productForm.closest('[data-otp-no-gifts="true"]');
    if (!card || card.dataset.purchaseType !== "one_time") return () => true;

    const keptHandles = (card.dataset.otpKeptGiftHandles || "")
      .split(",")
      .map((handle) => handle.trim().toLowerCase())
      .filter(Boolean);

    return (variantId) => {
      const handle = (window.freeGiftHandles || {})[variantId];
      return !!handle && keptHandles.includes(String(handle).toLowerCase());
    };
  }

  function handleButtonClick(button, showSpinner = true, addFreeGifts = true, applyDiscounts = true, redirect = true) {
    button.addEventListener("click", async function (event) {
      if (window.isCali) {
        document.querySelectorAll(".js-subscription-product").forEach((el) => {
          el.style.display = "block";
        });
      }

      event.stopPropagation();
      event.preventDefault();

      // Save original button text (if network request fails, we'll remove the spinner and put the original text back)
      var originalButtonText = button.innerHTML;

      // Swap the button text with our loader
      if (showSpinner) {
        button.innerHTML = `<div class="loading__spinner__add-to-cart"></div>`;
      }

      const productForm = button.closest("form");
      if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        const sellingPlanInput = productForm.querySelector(
          'input[name="selling_plan"]'
        );
        const quantityInput = productForm.querySelector('input[name="quantity"]');
        if (variantInput) {
          const variantId = variantInput.value;
          let body = {
            id: variantId,
            quantity: 1,
          };
          if (quantityInput && quantityInput.value >= 1) {
            body['quantity'] = parseInt(quantityInput.value);
          }
          if (sellingPlanInput) {
            body = { ...body, selling_plan: sellingPlanInput.value };
          }
          const productInput = productForm.querySelector(
            "input[data-product-id]"
          );
          // Buy Once under the no-gifts test: tag the line itself, so the cart's gift
          // reconciliation (validateCartGifts in cart.liquid) cannot re-add what the
          // guard withholds below. Underscore-prefixed properties stay hidden in the cart.
          const otpCard = productForm.closest('[data-otp-no-gifts="true"]');
          if (otpCard && otpCard.dataset.purchaseType === "one_time") {
            body.properties = {
              ...(body.properties || {}),
              _otp_no_gifts: "true",
              _otp_kept_gifts: otpCard.dataset.otpKeptGiftHandles || "",
            };
          }
          // Resolve free gifts: dynamic sale first, legacy fallback (see getGiftProductsToAdd in theme.liquid)
          let groupProductsToAdd = [];
          if (addFreeGifts && productInput) {
            const productId = productInput.getAttribute("data-product-id");
            groupProductsToAdd = await window.getGiftProductsToAdd(productId);
            // One-time-purchase cards keep only their listed gifts (main's OTP guard).
            const giftAllowed = createGiftGuard(productForm);
            groupProductsToAdd = groupProductsToAdd.filter((gift) => giftAllowed(gift.id));
          }

          groupProductsToAdd.unshift(body);
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: groupProductsToAdd,
            }),
          });

          if (response.ok) {

            const responseForKlaviyo = response.clone();
            if (showSpinner) {
              button.innerHTML = originalButtonText;
            }
            // btn.isClicked = true;
            // cart drawer:
            if (cart && cart.classList.contains("drawer")) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "add-to-cart",
                cartData: await response.json(),
                tagName: "CART-DRAWER-ITEMS",
                sections: cart
                  .getSectionsToRender()
                  .map((section) => section.id),
              });

                try {
                  const klaviyoData = await responseForKlaviyo.json();
                  trackKlaviyoAddToCart(klaviyoData, variantId);
                } catch (err) {
                  console.error("Klaviyo Tracking Error:", err);
                }

              button.innerHTML = originalButtonText;

              setTimeout(() => {
                if (cart && cart.classList.contains("is-empty"))
                  cart.classList.remove("is-empty");
                cart.renderContents(response);
              });
              if (
                window.cart_drawer_auto_close_delay &&
                window.cart_drawer_auto_close_delay > 0
              ) {
                cartCloseTimeout = setTimeout(() => {
                  cart.close();
                }, window.cart_drawer_auto_close_delay);
              }
            } else {
              try {
                const klaviyoData = await responseForKlaviyo.json();
                trackKlaviyoAddToCart(klaviyoData, variantId);
              } catch (err) {
                console.error("Klaviyo Tracking Error:", err);
              }


              // not using cart drawer:
              // Apply discount after successful product addition
              if (applyDiscounts) {
                const discountApplied = applyDiscountCode(productForm);

                if (!discountApplied && redirect) {
                  // If no discount to apply, proceed with normal redirect
                  setTimeout(() => {
                    // check if current page has /es or /fr in the URL
                    if (window.location.pathname.includes("/es")) {
                      window.location.href = "/es/cart";
                    } else if (window.location.pathname.includes("/fr")) {
                      window.location.href = "/fr/cart";
                    } else {
                      window.location.href = "/cart";
                    }
                  }, window.cart_redirect_delay || 0);
                }
              } else if (redirect) {
                setTimeout(() => {
                  if (window.location.pathname.includes("/es")) {
                    window.location.href = "/es/cart";
                  } else if (window.location.pathname.includes("/fr")) {
                    window.location.href = "/fr/cart";
                  } else {
                    window.location.href = "/cart";
                  }
                }, window.cart_redirect_delay || 0);
              }

              if (!redirect) {
                // If we aren't redirecting to cart after adding, check if item indicator bubble
                // is on the cart icon in the header. If not, add the bubble html. Currently used
                // on Food Portal B2B Shop All ATC
                const cartIcon = document.getElementById('cart-icon-bubble');
                if (cartIcon) {
                  const cartIconHasBubble = cartIcon.querySelector('.js-cart-item-count');

                  if (!cartIconHasBubble) {
                    cartIcon.innerHTML = `${cartIcon.innerHTML}<div class="js-cart-item-count Header-cartItemCount"></div>`;
                  }
                }
              }
            }
          } else {
            // If the network request failed, just reset the button with the original text
            if (showSpinner) {
              button.innerHTML = originalButtonText;
            }
          }
        }
      }
    });
  }
});
